export var ChannelsNames;
(function (ChannelsNames) {
    ChannelsNames["Blipchat"] = "blipchat";
    ChannelsNames["Instagram"] = "instagram";
    ChannelsNames["Mailgun"] = "mailgun";
    ChannelsNames["Messenger"] = "messenger";
    ChannelsNames["Telegram"] = "telegram";
    ChannelsNames["WhatsApp"] = "wa";
    ChannelsNames["Workplace"] = "workplace";
    ChannelsNames["AppleBusinessChat"] = "businesschat";
    ChannelsNames["Alexa"] = "alexa";
    ChannelsNames["ChatConversations"] = "chatconversations";
    ChannelsNames["Assistant"] = "assistant";
    ChannelsNames["BusinessMessages"] = "businessmessages";
    ChannelsNames["Firebase"] = "firebase";
    ChannelsNames["GoogleRCS"] = "googlercs";
    ChannelsNames["Infobip"] = "infobip";
    ChannelsNames["ABS"] = "abs";
    ChannelsNames["Skype"] = "skype";
    ChannelsNames["PagSeguro"] = "pagseguro";
    ChannelsNames["Custom"] = "custom";
    ChannelsNames["TakeIO"] = "takeio";
    ChannelsNames["Tangram"] = "tangram";
    ChannelsNames["Zendesk"] = "zendesk";
    ChannelsNames["GCM"] = "gcm";
    ChannelsNames["Sms"] = "sms";
    ChannelsNames["TikTok"] = "tiktok";
    /**
     * @deprecated Remove after MH extension
     */
    ChannelsNames["Facebook"] = "facebook";
})(ChannelsNames || (ChannelsNames = {}));
export var ChannelsDeploymentStatuses;
(function (ChannelsDeploymentStatuses) {
    ChannelsDeploymentStatuses["Public"] = "public";
    ChannelsDeploymentStatuses["Testing"] = "testing";
    ChannelsDeploymentStatuses["Ready"] = "ready";
    ChannelsDeploymentStatuses["Unknown"] = "unknown";
})(ChannelsDeploymentStatuses || (ChannelsDeploymentStatuses = {}));
export const ChannelsWithDeployment = [
    ChannelsNames.WhatsApp,
];
